/**
 * Determines if the event day recirc should be shown based on the provided flags, vertical,
 * item taxonomies, and event day list. Allows targeting of child taxonomies with a trailing '*'.
 * @param {object} flags
 * @param {string} vertical
 * @param {string[]} itemTaxonomies
 * @param {object} eventDayList
 */
export function getShouldShowEventDayRecirc(
  flags,
  vertical,
  itemTaxonomies = [],
  eventDayList,
) {
  const targetedTaxonomies = flags?.[`event-day-curated-list-${vertical}`]?.taxonomy ?? [];

  // true if any item taxonomy matches any targeted taxonomy pattern
  const hasTaxonomyMatch = itemTaxonomies.some((itemTax) => targetedTaxonomies.some((pattern) => {
    if (typeof pattern !== 'string') return false;

    const p = pattern.trim();
    if (p.endsWith('*')) {
      // drop the trailing * and check prefix
      return itemTax.startsWith(p.slice(0, -1));
    }
    return itemTax === p; // literal match
  }));

  return eventDayList?.content?.items?.length > 0 && hasTaxonomyMatch;
}
